import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import Router from '@/router/index';
import baseUrl from './baseUrl';
import {
  Cookie,
  Storage
} from '@/utils/utils';
let pending = []; // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
// const CancelToken = axios.CancelToken;
axios.defaults.withCredentials = true
axios.defaults.crossDomain = true
const encodeSearchKey = (key) => {
  if (!key) { return key }
  const encodeArr = [{
    code: '%',
    encode: '%25'
  }, {
    code: '?',
    encode: '%3F'
  }, {
    code: '#',
    encode: '%23'
  }, {
    code: '&',
    encode: '%26'
  }, {
    code: '=',
    encode: '%3D'
  }];
  return key.replace(/[%?#&=]/g, ($, index, str) => {
    for (const k of encodeArr) {
      if (k.code === $) {
        return k.encode;
      }
    }
  });
}
const removePending = () => {
  for (let i = 0; i < pending.length; i++) {
    pending[i].f();
    pending = [];
  }
};
const removeRepeat = (ever) => {
  for (let i = 0; i < pending.length; i++) {
    if (pending[i].u === ever.url) {
      pending[i].f();
      pending.splice(i, 1); // 把这条记录从数组中移除
    }
  }
};
// 请求拦截
axios.interceptors.request.use(
  (config) => {
    const obj = config;
    obj.cancelToken = new axios.CancelToken((c) => {
      pending.push({
        u: config.url,
        f: c
      });
    });
    return config;
  },
  error => Promise.reject(error),
);

// 返回拦截
axios.interceptors.response.use(
  (response) => response,
  error => Promise.resolve(error.response),
);

function successState(res, opts) {
  // 统一判断后端返回的错误码
  // 默认弹出错误, isAlertErr: false 不弹出错误
  if (res.status == 401 || res.data.code === 50008) {
    Storage.remove('wfUserInfo')
    Storage.clearSession()
    Router.push({
      path: '/login'
    });
    Router.go(0)
    Vue.prototype.$message.error('身份已过期，请重新登录');
    return
  }
  if (!opts.hasOwnProperty('isAlertErr') || (opts.hasOwnProperty('isAlertErr') && opts.isAlertErr !== false)) {
    Vue.prototype.$message.error(res.data.message || '网络异常');
  }
}

function exportData(data, fileName = '导出表.xls') {
  const content = data
  const blob = new Blob([content], { type: 'application/octet-stream' })
  const downloadUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = downloadUrl
  link.download = fileName.replace(new RegExp('"', 'g'), '')// 移除可能存在的引号
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(downloadUrl)
}

function errorState(response, opts) {
  // 如果http状态码正常，则直接返回数据
  console.log('异常返回', response)
  if (response && (response.status !== 200 || response.status !== 304 || response.status !== 400)) {
    Vue.prototype.$message.error('网络异常');
  }
  return response;
}

const httpServer = (opts, data) => {

  // 这里做data数据过滤,如果是空数组需要把对应项设置为null
  for (let i in data) {
    if (typeof data[i] === 'string') {
      data[i] = data[i].trim()
    }
    if (Array.isArray(data[i]) && data[i].length === 0) {
      data[i] = ''
    }
  }
  const Public = {};
  const httpDefaultOpts = {
    baseURL: baseUrl.baseUrl,
    method: opts.method,
    cache: false,
    url: opts.method === 'get' ? opts.url + `?v=${Math.random()}` : opts.url,
    timeout: 30000,
    params: Object.assign(Public, data),
    data: opts.isUpload ? data : qs.stringify(Object.assign(Public, data), { strictNullHandling: true }),
    headers: opts.method === 'get' ? {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8',
    } : {
      //'X-Requested-With': 'XMLHttpRequest',
      //'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
  };
  if (process.env.NODE_ENV === 'development') {
    delete httpDefaultOpts.baseURL;
  }
  if (opts.method === 'get') {
    delete httpDefaultOpts.data;
  } else {
    delete httpDefaultOpts.params;
  }
  if (opts.hasOwnProperty('isJSON') && opts.isJSON === true) {
    httpDefaultOpts.headers = {
      'Content-Type': 'application/json; charset=utf-8',
    };
    httpDefaultOpts.data = decodeURIComponent(encodeSearchKey(JSON.stringify(data)));
  }
  if (opts.hasOwnProperty('isUpload') && opts.isUpload === true) {
    httpDefaultOpts.headers = {
      'Content-Type': 'multipart/form-data',
    };
  }
  if (opts.hasOwnProperty('isFile') && opts.isFile === true) {
    httpDefaultOpts.responseType = 'blob'
    httpDefaultOpts.timeout = 0
  }
  if (opts.hasOwnProperty('timeout') && opts.timeout === true) {
    //如果timeout为true 则不限制请求时间
    httpDefaultOpts.timeout = 0
  }
  if (Storage.get('wfUserInfo')) {
    httpDefaultOpts.headers['X-TOKEN'] = Storage.get('wfUserInfo').token
  }
  return new Promise((resolve, reject) => {
    axios(httpDefaultOpts).then((res) => {
      if (res && res.data && opts.isFile) {
        console.log('上传文件获取的文件名', res)
        resolve(res)
        exportData(res.data, data.attachment_name || decodeURIComponent(res.headers['content-disposition'].split('filename=')[1]))
      } else if (res && res.data && (res.status === 200) && res.data.status > 0) {
        resolve(res.data.data || res.data.result);
      } else if (res) {
        reject(res.data);
        successState(res, opts);
      }
    }).catch((err) => {
      reject(err);
      errorState(err);
    });
  });
};
export default httpServer;
